import React, { useEffect, useState } from 'react';
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Tabs, Tab } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';
import Froala from './froala';
import './projectprogress.css';
import { useSelector } from 'react-redux';
// Require Font Awesome.
import 'font-awesome/css/font-awesome.css';
import { Link, useParams } from 'react-router-dom';
// import { height } from 'dom-helpers';


const GroupProjectProgress = () => {
  console.log('GroupProjectProgress');
  const permissions = useSelector((state) => state.permissions);
  const { id, groupid } = useParams();
  const [pro, setPro] = useState({name: '', description: '', template: '', bgcolor: '', fgcolor: '', project: '', about_school: '', ela_connection: '', math_connection: '', sse: '', engandtech: ''});
  const [locked,setLocked]=useState('');
  const getProject = async()=>{
    try {
      let res = await axios.post(`${BASE_URL}/student/getgroupproject.php`, {proid: id, groupid});
      setPro(res.data.data?.project || {});
      setLocked(res.data.data.locked)
    }catch(e) {
      Swal.fire('Error while getting project', '', 'error');
    }
  };


  useEffect(async()=> {
    await getProject();
    // await showDesc();
  }, []);


const sectionContent = (html) => {
  return (
    <div dangerouslySetInnerHTML={{__html:html}}>

    </div>
  )
}
// Tabs and its content
  const ControlledTabs = ()=> {
    const [key, setKey] = useState('intro');

    return (
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3 m-auto text-center fs-6 justify-content-center align-items-center fw-bold gap-4"
      >
        <Tab eventKey="intro" title="Intro">
          {/* <Sonnet /> */}
          <div className="pt-5">
            <h1 className="text-left fw-bold ps-4">
              {pro.name}
            </h1>
            <h5 className="text-left fw-bold ps-4">
              Description:-
            </h5>
            {sectionContent(pro.description)}
          </div>
        </Tab>
        {/* <Tab eventKey="project" title="Project">
          <div className='text-left ps-5 mt-5'>
            <h4 className='fw-bold'>This part should cover those keypoints:</h4>
            <ul className='ps-5 list-group list-group-horizontal'>
              <li className='list-group-item fw-bold'>Introduction</li>
              <li className='list-group-item fw-bold'>Materials</li>
              <li className='list-group-item fw-bold'>Procedure</li>
              <li className='list-group-item fw-bold'>Scientific Principle</li>
            </ul>
          </div>
          <div className="text-center p-5">
              <Froala {...permissions} type={'ind'} data={pro.project} idx={`project${+key}`} proId={id} section={'project'} />
          </div>
        </Tab> */}
        <Tab eventKey="about" title="About School">
          <div className="text-center p-5">
              <Froala locked={locked} {...permissions} type={'group'} data={pro.about_school} idx={`about_school${+key}`} proId={id} gId={groupid} section={'about_school'}/>
          </div>
        </Tab>
        <Tab eventKey="ela" title="ELA Connection">
          <div className="text-center p-5">
            <Froala locked={locked} {...permissions} type={'group'} data={pro.ela_connection} idx={`ela_connection${+key}`} proId={id} gId={groupid} section={'ela_connection'}/>
          </div>
        </Tab>
        <Tab eventKey="math" title="Math Connection">
          <div className="text-center p-5">
            <Froala locked={locked} {...permissions} type={'group'} data={pro.math_connection} idx={`math_connection${+key}`} proId={id} gId={groupid} section={'math_connection'}/>
          </div>
        </Tab>
        {/*         <Tab eventKey="sse" title="S.S.E">
          <div className="text-center p-5">
            <Froala {...permissions} type={'ind'} data={pro.sse} idx={`sse${+key}`} proId={id} section={'sse'}/>
          </div>
        </Tab> */}
        <Tab eventKey="eat" title="Engineering &amp; Technologies">
          <div className="text-center p-5">
            <Froala locked={locked} {...permissions} type={'group'} data={pro.engandtech} idx={`engandtech${+key}`} proId={id} gId={groupid} section={'engandtech'}/>
          </div>
        </Tab>
      </Tabs>
    )
  };

  return (
    <>

      <PanelHeader size="sm" />
      <div className='w-100 bg-dark' style={{position: 'fixed', top: '60px', zIndex: 2, height: '60px'}}>
        <Link style={{position: 'fixed', display: 'block', width: '100px'}} to={`/groupprojects`} className='btn btn-primary fs-5 p-2 fw-bolder ms-3'><i className="fas fa-arrow-left fa-lg"></i></Link>
      </div>
      <div style={{position: 'absolute'}} className="text-center w-100 mx-auto mt-5 content">
          <ControlledTabs />
      </div>
    </>
  );
};

export default GroupProjectProgress;
